export default {
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  lastFetchTime: state => state.lastFetchTime,
  chatgroups: state => state.chatgroups,
  chatgroup: state => state.chatgroup,
  messages: state => state.messages,
  isChecked: state => state.isChecked,
  channels: state => state.channels
}



// WEBPACK FOOTER //
// ./src/store/modules/chatadmin/getters.js